import axios from 'axios';

export const postGame = async (game) => {
  return axios
    .post('/game', game)
    .then((res) => {
        return res;
    })
    .catch((err) => {
      

      throw err;
    });
};

export const fetchGame = async (gameId) => {
  return axios
    .get(`/game/${gameId}`)
    .then((res) => {
      // Process the data to ensure consistent creatorHandle
      const gameData = res.data;
      if (!gameData.creatorHandle && gameData.creator) {
        // If creator is a string (not a userId), use it as handle
        if (typeof gameData.creator === 'string' && !gameData.creator.includes(' ')) {
          gameData.creatorHandle = gameData.creator;
        }
      }
      return gameData;
    })
    .catch((err) => {
      // console.error('Error fetching game:', err);
      // Don't throw the error for 403 (unauthorized) responses
      // This allows non-authenticated users to still get the error message
      // but not have the promise rejected completely
      if (err.response && err.response.status === 403) {
        return {
          error: 'Authentication required',
          isAuthError: true
        };
      }
      // Handle 404 (not found) responses for missing/deleted games
      if (err.response && err.response.status === 404) {
        return {
          error: 'Game not found',
          isNotFound: true
        };
      }
      throw err;
    });
}

export const fetchNextGame = async (gameId, orderBy, creatorIdentifier, tag) => {
  // creatorIdentifier can be either userId or handle
  return axios
    .get(`/game/${gameId}/next?
      ${orderBy ? `&orderBy=${orderBy}` : ''}
      ${tag ? `&tag=${tag}` : ''}
      ${creatorIdentifier ? `&userId=${creatorIdentifier}` : ''}`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      // console.error('Error fetching next game:', err);
      // Don't throw the error for 403 (unauthorized) responses
      if (err.response && err.response.status === 403) {
        return null; // Return null instead of throwing for unauthorized users
      }
      throw err;
    });
}

export const fetchPrevGame = async (gameId, orderBy, creatorIdentifier, tag) => {
  // creatorIdentifier can be either userId or handle
  return axios
    .get(`/game/${gameId}/prev?
      ${orderBy ? `&orderBy=${orderBy}` : ''}
      ${tag ? `&tag=${tag}` : ''}
      ${creatorIdentifier ? `&userId=${creatorIdentifier}` : ''}`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      // console.error('Error fetching previous game:', err);
      // Don't throw the error for 403 (unauthorized) responses
      if (err.response && err.response.status === 403) {
        return null; // Return null instead of throwing for unauthorized users
      }
      throw err;
    });
}

export const putGame = async (gameId, game) => {
  return axios
    .put(`/game/${gameId}`, game)
    .then((res) => {
        return res;
    })
    .catch((err) => {
      

      throw err;
    });
};

// export const fetchGames = async (limit = 10, tag = null) => {

  // try {
  //   // Build the query parameters
  //   let queryParams = '';
  //   if (limit) {
  //     queryParams += `limit=${limit}`;
  //   }
  //   if (tag) {
  //     queryParams += queryParams ? `&tag=${tag}` : `tag=${tag}`;
  //   }
    
  //   return axios
  //     .get(`/games${queryParams ? `?${queryParams}` : ''}`)
  //     .then((res) => {
  //       return res.data;
  //     })
  //     .catch((err) => {
  //       // console.error("Error fetching games:", err);
  //       throw err;
  //     });
  // } catch (error) {
  //   // console.error("Error in fetchGames:", error);
  //   throw error;
  // }


  // Increase Pagination Limit -- April 23rd
  // export const fetchGames = async (limit = 10, tag = null, difficulty = null) => {
  //   const queryParams = new URLSearchParams();
    
  //   if (limit) {
  //     queryParams.append('limit', limit);
  //   }
    
  //   if (tag) {
  //     queryParams.append('tag', tag);
  //   }
    
  //   // Note: We're still sending the difficulty parameter to the backend
  //   // so it's ready when the backend adds support for it
  //   if (difficulty) {
  //     queryParams.append('difficulty', difficulty);
  //   }
  
    
  //   return axios
  //     .get(`/games?${queryParams.toString()}`)
  //     .then((res) => {
  //       let games = res.data;
        
  //       

export const fetchGames = async (limit = 10, tag = null, difficulty = null, creatorHandle = null, cursor = null) => {
  try {
    // Build query parameters in a cleaner way
    const queryParams = new URLSearchParams();
    
    if (limit) {
      queryParams.append('limit', limit);
    }
    
    if (tag) {
      queryParams.append('tag', tag);
    }
    
    if (difficulty && difficulty !== "All Levels") {
      queryParams.append('difficulty', difficulty);
    }
    
    if (cursor) {
      queryParams.append('cursor', cursor);
    }
    
    let hasCreatorFilter = false;
    
    // Try different approaches to filter by creator
    if (creatorHandle) {
      hasCreatorFilter = true;
      // First try with creatorHandle parameter
      queryParams.append('creatorHandle', creatorHandle);
      

      // if (games && games.length > 0) {
      
      // Log the request parameters for debugging
      
      
      try {
        // Add timestamp to prevent caching
        queryParams.append('_t', Date.now());





 // Log all games with their tags and difficulty for debugging
//  games.forEach((game, index) => {
          
//  });
// }

// // Client-side filtering for difficulty if a value is provided and not "All Levels"
// if (difficulty && difficulty !== "All Levels" && Array.isArray(games)) {
//  
//  
 
//  // Get unique difficulty values for debugging
//  const uniqueDifficulties = [...new Set(games.map(game => game.difficulty))];
//  
 
//  // Filter games that match the selected difficulty
//  games = games.filter(game => game.difficulty === difficulty);
 
//  
 
//  // Log the filtered games to check if any remaining games have the expected tag
//  if (tag) {
//    const gamesWithMatchingTag = games.filter(game => 
//      Array.isArray(game.tags) && game.tags.includes(tag)
//    );
//    
//  }
// }

// // Double-check tag filtering if a tag is specified
// if (tag && Array.isArray(games)) {
//  
//  const gamesWithTag = games.filter(game => 
//    Array.isArray(game.tags) && game.tags.includes(tag)
//  );
//  
 
//  // Always apply client-side tag filtering for consistency
//  // This guarantees we only show games that match the tag
//  
//  games = gamesWithTag;
// }

// return games;
// })
// .catch((err) => {
// // console.error("Error in fetchGames:", err);
// // Don't throw the error for 403 (unauthorized) responses
// if (err.response && err.response.status === 403) {
//  return [];
// }
// throw err;
// });
// };



        
        const response = await axios.get(`/games?${queryParams.toString()}`);
        
        // Process response
        return processGamesResponse(response, limit);
      } catch (error) {
        // console.error("Error with creatorHandle parameter:", error);
        
        // If the server returns an error, try with userId parameter instead
        if (error.response && error.response.status >= 400) {
          
          
          // Remove creatorHandle and try with userId
          queryParams.delete('creatorHandle');
          queryParams.append('userId', creatorHandle); // Try using the handle as userId
          
          try {
            const retryResponse = await axios.get(`/games?${queryParams.toString()}`);
            return processGamesResponse(retryResponse, limit);
          } catch (retryError) {
            // console.error("Error with userId parameter fallback:", retryError);
            // Fall through to return the empty result below
          }
        }
      }
    }
    
    // If we're here with a creatorFilter, it means both approaches failed
    if (hasCreatorFilter) {
      console.warn("All creator filter approaches failed, returning empty result");
      return { games: [], nextCursor: null, hasMore: false };
    }
    
    // Normal case (no creator filter or no fallback needed)
    if (!hasCreatorFilter) {
      // Add timestamp to prevent caching
      queryParams.append('_t', Date.now());
      
      
      
      const response = await axios.get(`/games?${queryParams.toString()}`);
      return processGamesResponse(response, limit);
    }
    
  } catch (err) {
    // console.error("Error in fetchGames:", err);
    
    // Handle specific error types
    if (err.response && err.response.status === 403) {
      console.warn("Authentication error fetching games");
      return { games: [], nextCursor: null, hasMore: false, error: "auth" };
    }
    
    // For all other errors
    return { games: [], nextCursor: null, hasMore: false, error: err.message };
  }
};

// Helper function to process the games response
function processGamesResponse(response, limit) {
  let games = response.data;
  
  // Handle API responses that might be directly the array or in a data property
  if (!Array.isArray(games) && games.games) {
    games = games.games;
  }
  
  // If response has structured cursor-based pagination info
  const hasMoreData = response.data.hasMore !== undefined 
    ? response.data.hasMore 
    : games.length >= limit;
    
  const nextCursor = response.data.cursor || 
    (games.length > 0 ? games[games.length - 1].id : null);
  
  
  
  // Return consistent structure regardless of API response format
  return {
    games: Array.isArray(games) ? games : [],
    nextCursor,
    hasMore: hasMoreData
  };
}


// export const fetchGames = async (limit = 5, offset = 0, tag, userId, creatorHandle) => {
  // Now we explicitly separate userId and creatorHandle parameters
  // Add a timestamp to prevent caching
  // const timestamp = new Date().getTime();
  // 
  
  // Clean up the URL construction to avoid issues with spaces and formatting
 //  let url = `/games?limit=${limit}&offset=${offset || 0}`;
  
  // if (tag) url += `&tag=${encodeURIComponent(tag)}`;
  // if (userId) url += `&userId=${encodeURIComponent(userId)}`;
  // if (creatorHandle) url += `&creatorHandle=${encodeURIComponent(creatorHandle)}`;
  
  // Add timestamp to prevent caching
  // url += `&_t=${timestamp}`;
  
  // 
  
  // return axios
  //   .get(url)
  //   .then((res) => {
  //     return res.data;
  //   })
  //   .catch((err) => {
  //     
  //     throw err;
  //   });
  // }